__turbopack_context__.v({
  "className": "sora_937130b5-module__AJH3mG__className",
});
